import { createSelector } from 'reselect';
import { statuses } from "../../../../config";

const loadingOffer = (state) => state.offers.loading;
const offers = (state) => state.offers.list;
const loadingGoalEntries = (state) => state.goalEntries.loading;
const goalEntries = (state) => state.goalEntries.list;

export const getLoading = createSelector(
    loadingOffer,
    loadingGoalEntries,
    (loadingOffer, loadingGoalEntries) => {
        return loadingOffer || loadingGoalEntries;
    }
);

export const isEmpty = createSelector(
    offers,
    goalEntries,
    (offers = [], goalEntries = []) => {
        let offer = offers[0] || {};

        return !Object.keys(offer).length || !goalEntries.length;
    }
);

export const isPaused = createSelector(
    goalEntries,
    (goalEntries = []) => {
        let countPaused = 0;

        goalEntries.map((item) => {
            item.status === statuses.paused && (countPaused += 1);
        });

        return goalEntries.length === countPaused;
    }
);
